import { SUBSCRIBE_TO_WS, UNSUBSCRIBE_FROM_WS } from '../constants/actionTypes';

export const subscribe = payload => ({ type: SUBSCRIBE_TO_WS, payload });
export const unsubscribe = payload => ({ type: UNSUBSCRIBE_FROM_WS, payload });

export default {
  subscribe,
  unsubscribe
};
